import React, { useCallback, useEffect, useState, useContext } from "react";
import _ from 'lodash';

import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { BreakpointTrackerContext } from "@jutro/layout";
import PropTypes from 'prop-types';

import styles from './BasicQuote.module.scss';
import metadata from './BasicQuote.metadata.json5';
import './BasicQuote.messages';
import { useModal } from "@jutro/components";
import CoveragesPopUp from "./QuoteCoveragesPopover/CoveragesPopUp";

let propsData;

function BasicQuote(props) {
     const { showModal } = useModal();
    const { submissionVM } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const checkCoverage = ['PAComprehensiveCov', 'PACollisionCov', 'PALeaseLoan_alfa', 'PATowingLaborCov', 'PALossOfUseCov_alfa', 'PALossOfIncome_alfa'];
    let lineCoverage = ['PABI_alfa', 'PAPropertyDamage_alfa', 'PAMedicalPayments_alfa', 'PAUninsuredMotoristBI_alfa', 'PAADD_alfa', 'PAAccidentWaiver_alfa'];
    
    const preparePolicyCovProps = () => {
        let stateCategory = '';
        for (let data of submissionVM.lobData.personalAuto.offerings.value) {
            if (data.branchCode === 'PABasic') {
                stateCategory = 'PABasic';
                break;
            } else if (data.branchCode === 'PABasicGA') {
                stateCategory = 'PABasicGA';
                break;
            } else if (data.branchCode === 'PABasicMS') {
                stateCategory = 'PABasicMS';
                break;
            }
        }
        return stateCategory;
    }
    propsData = preparePolicyCovProps();
    const convertToAmount = (amount) => {
        if (!_.isEmpty(amount)) {
            const decimalPoint = amount.split('.')[1];
            if (!_.isEmpty(decimalPoint) && decimalPoint.length === 1) {
                return `$${amount}0`;
            }
        }
        return `$${amount}`;
    };

     const subHeader = (data) => {
     const newArray = data.map((person) => {
            if (person.pid === "PABI_alfa" || person.pid === "PAUninsuredMotoristBI_alfa") {
                    return { ...person, subHeader: "Each Person / Each Accident" }; 
                    } else if ((person.pid === "PAPropertyDamage_alfa" || person.pid === "PAUninsuredMotoristPD_alfa")) {
                    return { ...person, subHeader: "Each Accident"};
                    } else if (person.pid === "PAMedicalPayments_alfa") {
                    return { ...person, subHeader: "Each Person"};
                    } else {
                    return { ...person, subHeader:  ""};
                    }
    });
        return newArray
    }

    const getVehicleCoverage = useCallback(() => {
        const vehicleMockArray = [];
        submissionVM.lobData.personalAuto.offerings.value.map((object) => {
            if ((object.branchCode === 'PABasic' || object.branchCode === 'PABasicGA' || object.branchCode === 'PABasicMS') && object.branchName === 'Basic Program') {
                object.coverages.vehicleCoverages.map((vehicleObject) => {
                    const eachVehicleArray = [];
                    vehicleObject.coverages.map((coverage,) => {
                        if (checkCoverage.includes(coverage.publicID)) {
                            let term = '';
                            if (!_.isEmpty(coverage.terms)) {
                                const isRoadSideAsstCov = coverage.publicID !== 'PATowingLaborCov' ? coverage.terms[0].chosenTermValue : 'Included';
                                term = !coverage.terms[0].chosenTermValue ? 'Not Included' : isRoadSideAsstCov;
                            } else {
                                term = 'Not Included';
                            }
                            const a = {
                                pid: coverage.publicID,
                                name: coverage.name,
                                term: term,
                                amount: coverage.amount !== undefined ? convertToAmount(`${coverage.amount.amount}`) : '$0.00',
                                learnMore: 'Learn More'
                            };
                            if (!eachVehicleArray.includes(a)) {
                                eachVehicleArray.push(a);
                            }
                        }
                        return eachVehicleArray;
                    });
                    if (!_.isEmpty(eachVehicleArray)) {
                        eachVehicleArray.sort((a, b) => {
                            return checkCoverage.indexOf(a.pid) - checkCoverage.indexOf(b.pid);
                        });
                        const updatedVehicleMockArray = subHeader(eachVehicleArray);
                        const vehicleObj = {
                            name: vehicleObject.vehicleName,
                            coverages: updatedVehicleMockArray
                        };
                        vehicleMockArray.push(vehicleObj);
                    }
                    return vehicleMockArray;
                });
            }
        });

        return vehicleMockArray;
    }, [submissionVM]);

    const vehicleCoverage = getVehicleCoverage();
    const [tableData, updateTableData] = useState(vehicleCoverage);
    useEffect(() => {

    }, []);


    const learnMoreModal = (data) => {
        const modalData = { modalId: data.pid, value: data.term, name: data.name };
        return showModal(<CoveragesPopUp {...modalData}/>);
    };

    const getVehicleLinecoverage = (columnData) => {
        if (columnData) {
            let vehicleLineCoverage = [];
            for (let data = 0; data < columnData.length; data++) {
                if(columnData[data].branchCode === 'PABasic') {
                    vehicleLineCoverage = ['PABI_alfa', 'PAPropertyDamage_alfa',
                    'PAMedicalPayments_alfa', 'PAUninsuredMotoristBI_alfa',
                    'PAADD_alfa', 'PAAccidentWaiver_alfa'];
                    break;
                } else if(columnData[data].branchCode === 'PABasicGA' || columnData[data].branchCode === 'PABasicMS') {
                    vehicleLineCoverage = [
                        'PABI_alfa', 'PAPropertyDamage_alfa',
                        'PAMedicalPayments_alfa', 'PAUninsuredMotoristBI_alfa',
                        'PAUninsuredMotoristPD_alfa',
                        'PAUninsuredMotoristCommon_alfa',
                        'PAADD_alfa', 'PAAccidentWaiver_alfa',
                    ];
                    break;
                }
            }
            lineCoverage = vehicleLineCoverage;
        }
    }

    const getCoverageLabel = (name, termObj) => {
        if (termObj.name.includes('Reduced or Added On')) {
            return "Uninsured Motorist - Reduced or Added On";
        }
        return "Uninsured Motorist - Deductible";
    }

    const getPolicyCoverage = useCallback(() => {
        getVehicleLinecoverage(submissionVM.lobData.personalAuto.offerings.value);
        const lineMockArray = [];
        submissionVM.lobData.personalAuto.offerings.value.map((object) => {
            if (object.branchCode === 'PABasic' || object.branchCode === 'PABasicGA' || object.branchCode === 'PABasicMS') {
                object.coverages.lineCoverages.map((coverage) => {
                    if (lineCoverage.includes(coverage.publicID)) {
                        let term = '';
                        if (!_.isEmpty(coverage.terms)) {
                            term = coverage.terms[0].chosenTermValue !== '' ? coverage.terms[0].chosenTermValue : 'Not Included';
                        } else {
                            term = 'Not Included';
                        }
                        const a = {
                            pid: coverage.publicID,
                            name: coverage.name,
                            term: term,
                            amount: coverage.amount !== undefined ? convertToAmount(`${coverage.amount.amount}`) : '$0.00',
                            learnMore: 'Learn More',
                        };
                        const exist = lineMockArray.filter((l) => l.name === a.name);
                        if (_.isEmpty(exist)) {
                            lineMockArray.push(a);
                        }
                    }
                    return lineMockArray;
                });
                object.coverages.vehicleCoverages.map((vehicleObject) => {
                    vehicleObject.coverages.map((coverage,) => {
                        if (lineCoverage.includes(coverage.publicID)) {
                            if (coverage.publicID !== 'PAUninsuredMotoristCommon_alfa') {
                                let term = '';
                                if (!_.isEmpty(coverage.terms)) {
                                    term = coverage.terms[0].chosenTermValue !== '' ? coverage.terms[0].chosenTermValue : 'Not Included';
                                } else {
                                    term = 'Not Included';
                                }
                                const a = {
                                    pid: coverage.publicID,
                                    name: coverage.name,
                                    term: term,
                                    amount: coverage.amount !== undefined ? convertToAmount(`${coverage.amount.amount}`) : '$0.00',
                                    learnMore : 'Learn More'
                                };
                                const exist = lineMockArray.filter((l) => l.name === a.name);
                                if (_.isEmpty(exist)) {
                                    lineMockArray.push(a);
                                }
                            } else {
                                _.forEach(coverage.terms, (termObj) => {                                
                                    let term = '';
                                    if (!_.isEmpty(coverage.terms)) {
                                        term = termObj.chosenTermValue !== '' ? termObj.chosenTermValue : 'Not Included';
                                    } else {
                                        term = 'Not Included';
                                    }
                                    const a = {
                                        pid: coverage.publicID,
                                        name: getCoverageLabel(coverage.name, termObj),
                                        term: term,
                                        amount: coverage.amount !== undefined ? convertToAmount(`${coverage.amount.amount}`) : '$0.00',
                                        learnMore : 'Learn More'
                                    };
                                    lineMockArray.push(a);
                                });
                            }
                        }
                        return lineMockArray;
                    });
                    return lineMockArray;
                });
            }
            return lineMockArray;
        });
        if (lineMockArray !== undefined) {
            lineMockArray.sort((a, b) => {
                return lineCoverage.indexOf(a.pid) - lineCoverage.indexOf(b.pid);
            });
        }
        const updatedLineMockArray = subHeader(lineMockArray);
        return updatedLineMockArray;
    }, []);

    const generateVehicleOverrides = useCallback(() => {
        const overrides = tableData.map((tableInfo, index) => ({
            [`vehicleCoverageTableGrid${index}`]: {
                data: tableInfo.coverages
            },
            [`vehicleName${index}`]: {
                content: tableInfo.name
            }

        }));

        return Object.assign({}, ...overrides);
    }, [tableData]);


    const overrideProps = {
        policyCoverageTableGrid: {
            data: getPolicyCoverage(),
            visible: (breakpoint === "desktop" || breakpoint === "tablet" || breakpoint === 'phoneWide') ? true : false
        },
         policyCoverageTableGridMobile: {
            data: getPolicyCoverage(),
            visible: breakpoint === "phone" ? true : false
        },
        vehicleContainer: {
            data: tableData,
            visible: (breakpoint === "desktop" || breakpoint === "tablet" || breakpoint === 'phoneWide') ? true : false
        },
        vehicleContainerMobile: {
            data: tableData,
            visible: breakpoint === "phone" ? true : false
        },
        ...generateVehicleOverrides()
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [overrideProps, submissionVM]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            learnMoreModal: learnMoreModal,
            subHeader: subHeader
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

BasicQuote.propTypes = {
    submissionVM: PropTypes.shape({})
};
BasicQuote.defaultProps = {
    submissionVM: undefined
};
export default BasicQuote;
